<template>
    <div
        class="d-flex justify-content-between border-top mt-5 pt-10 dm-wrap-wizard-bottom-buttons"
    >
        <div class="mr-2">
            <Previous v-if="hasPrevious" @click="goToStep(previousStepRoute)" />
        </div>
        <div>
            <Next
                v-if="hasNext"
                @clicked="goToNextStep()"
                :saving="saving"
                :is_active="canGoNext"
            />
            <Submit v-else-if="hasSubmit" @clicked="goToStep('preview')" />
        </div>
    </div>
</template>

<script>
import Previous from "./partials/Previous.vue";
import Next from "./partials/Next.vue";
import Submit from "./partials/Submit.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState, mapActions } from "pinia";

export default {
    components: {
        Previous,
        Next,
        Submit,
    },

    data() {
        return {
            saving: false,
        };
    },

    computed: {
        ...mapState(useSubmissionWizardStore, [
            "steps_body",
            "current_route_name",
            "navigation_steps_in_order",
            "navigation_steps_desktop",
        ]),
        ...mapWritableState(useSubmissionWizardStore, [
            "bottom_navigation_rules",
        ]),

        currentStepKey() {
            return this.navigation_steps_in_order.indexOf(this.current_route_name);
        },

        currentStepDataNavigationData() {
            if (! this.navigation_steps_desktop) return null;
            return this.navigation_steps_desktop.find(step => step.slug == this.current_route_name);
        },

        isCurrentStepMandatory() {
            return (this.currentStepDataNavigationData)
                ? this.currentStepDataNavigationData.is_mandatory
                : false;
        },

        previousStepRoute() {
            let previousKey = this.currentStepKey - 1;
            if (this.navigation_steps_in_order[previousKey])
                return this.navigation_steps_in_order[previousKey];
        },

        nextStepRoute() {
            let previousKey = this.currentStepKey + 1;
            if (this.navigation_steps_in_order[previousKey])
                return this.navigation_steps_in_order[previousKey];
        },

        hasPrevious() {
            return this.previousStepRoute && this.previousStepRoute.length > 0;
        },

        hasNext() {
            return this.nextStepRoute && this.nextStepRoute.length > 0;
        },

        hasSubmit() {
            let lastStepIndex = this.navigation_steps_in_order.length - 1;
            return (
                this.navigation_steps_in_order[lastStepIndex] ==
                this.current_route_name
            );
        },

        canGoNext() {
            if (! this.isCurrentStepMandatory) return true;

            if (!this.bottom_navigation_rules) return false;
            if (!this.bottom_navigation_rules.can_go_next) return false;
            return this.bottom_navigation_rules.can_go_next;
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["savePresentation"]),

        goToStep(stepIndex) {
            this.$router.push({ name: stepIndex }); // NOTE: stepIndex nmatched the slug and the vue router name. // TODO: Refactor / rething this like. Extract to Store.
            this.scrollToTop();
        },

        scrollToTop() {
            jQuery("html, body").animate({ scrollTop: 0 });
        },

        goToNextStep() {
            // this.saving = true;

            // Hardcode some save calls because we don't have a proper Vue Editor trigger. Detailed Summary and Description.
            // TODO: Review this list. It's likely not longer 100% correct.
            if (
                this.current_route_name == "description" ||
                this.current_route_name == "title" ||
                this.current_route_name == "core-message" ||
                this.current_route_name == "detailed-summary"
            ) {
                this.savePresentation();
            }

            var self = this;
            if (!self.nextStepRoute) return; // Prevents an error in the console.

            self.goToStep(self.nextStepRoute);
        },
    },
};
</script>
